import React from 'react';
import 'twin.macro';
import { Paragraph } from '../text';
import { DividerTitle } from '../divider';
import { ContactForm } from '../form';
import { MenuHeader, MenuContent } from './';

export const ContactInformation = () => {
  return (
    <Paragraph>
      Check eerst de{' '}
      <a href='/veelgestelde-vragen' target='_blank' rel='noopener noreferrer'>
        veelgestelde vragen
      </a>{' '}
      voordat je ons gaat mailen. Staat je antwoord daar niet tussen dan kan je de volgende stappen
      ondernemen:
      <br />
      <br />
      Kies hieronder het onderwerp waarover je contact wil opnemen. Iets insturen kan via 'Uploaden
      of linktippen' in het menu.
      <br />
      <br />
      Heb je een klacht over een bepaald filmpje of foto? Dat verbaast ons niks, daar ben je
      Nederlander voor. Kies dan 'verwijderverzoek' en <strong>VERGEET NIET</strong> te vermelden
      over welke post het precies gaat en je relatie tot deze content. Anders nemen we je klacht
      simpelweg niet in behandeling.
    </Paragraph>
  );
};

export const ContactMenu = ({ selectedOption, selectedProblem }) => {
  return (
    <>
      <MenuHeader title='Contact' />
      <MenuContent>
        <ContactInformation />
        <DividerTitle title='Ik mail over' tw='mt-6 mb-4' />
        <ContactForm selectedOption={selectedOption} selectedProblem={selectedProblem} />
      </MenuContent>
    </>
  );
};
